import React from 'react';
import PropTypes from 'prop-types';
import './Tooltip.css';

function Tooltip({ title = null, description = null, isVisible, style }) {
  return (
    <div className={`x-tooltip ${isVisible && `visible`}`} style={{...style}} >
      <p className={`x-tooltip-title type-regular`}><b>{title}</b></p>
      <span className={`type-regular type-secondary`}>{description}</span>
    </div>
  )
}

Tooltip.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  isVisible: PropTypes.bool,
  style: PropTypes.object
}

export default Tooltip;
